var map = {
	"./applications": 63287,
	"./applications.vue": 63287,
	"./catalogservices": 37656,
	"./catalogservices.vue": 37656
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 30231;
module.exports = webpackAsyncContext;